import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../axiosBaseQuery";
import { Response } from "../interfaces";
import { PredefinedPlan } from "./planTypes";

export const planApi = createApi({
  reducerPath: "planApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["plan"],
  endpoints: (builder) => ({
    getCreditPlan: builder.query<Response<PredefinedPlan[]>, undefined>({
      query: () => ({
        url: "credit-plan/list",
        method: "GET",
      }),
      providesTags: ["plan"],
    }),
    buyPlan: builder.mutation<
      Response<PredefinedPlan[]>,
      { credit_plan_id: string; card_id: string }
    >({
      query: (data) => ({
        url: "credit-plan/buy",
        method: "POST",
        data,
      }),
    }),
  }),
});

export const {
  useGetCreditPlanQuery,
  useLazyGetCreditPlanQuery,
  useBuyPlanMutation,
} = planApi;
